import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    st0: {
        fill: '#FFFFFF',
    },

    st1: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st2: {
        fontSize: '15px',
        // fontWeight: '600',
    },

    st3: {
        clipPath: 'url(#SVGID_2_)',
    },

}));
